export const REDUX = 'redux' 
export const LOGGED_IN = 'isLoggedIn'
export const USER_DETAILS = 'userDetails'
